module.exports = __webpack_public_path__ + "img/07.83e6d4e8.png";